export default "assets/images/icons/linkedin-a5474515.svg";